import { Link } from "react-router-dom";

/** A hero number. No plot, so no hover layer — a single headline figure is a
 *  stat tile, not a chart. Optionally links to the page that explains it. */
export function StatTile({ label, value, sub, status, to }: {
  label: string; value: string; sub?: string; status?: "good" | "warning" | "critical"; to?: string;
}) {
  const body = (
    <>
      <span className="tile-label">{label}</span>
      <span className={`tile-value${status ? ` is-${status}` : ""}`}>{value}</span>
      {sub && <span className="tile-sub">{sub}</span>}
    </>
  );
  return to ? <Link to={to} className="tile tile-link">{body}</Link> : <div className="tile">{body}</div>;
}
